import React, { useEffect, useState } from "react";
import axios from "axios";
// import BannerHorizontal from 'components/banners/BannerHorizontal'
// import RightNow from "~/components/RightNow";
import TipsHorizontal from "~/components/TipsHorizontal";
import TopArticles from "~/components/TopArticles";
import TopArticlesGrid from "~/components/TopArticlesGrid";
import HotTopics from "~/components/HotTopics";
// import ElectionsBanner from "~/components/specialBanners/ElectionsBanner";
import ElectionsBanner from "~/components/specialBanners/VolbyPrezident2024";
import ReferendumBanner from "~/components/specialBanners/Referendum2023";
import { asideMappingFactory } from "~/utility/aside";
import { getGaInfo } from "~/utility/gaInfo";
import { useWagonHeight } from "./wagonHeightHook";

const WagonIndex = (props) => {
  const gaInfo = getGaInfo(props, "wIndex");
  const [showElectionsBanner, setShowElectionsBanner] = useState(true);

  const asideMapping = asideMappingFactory({
    headerSuffix: "",
    gaInfo: gaInfo,
  });

  const getIp = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json");
    return res.data.ip;
  };

  const ipTASR = '195.46.72.';
  const ipKubo = '87.197.146.153';
  const ipKuboDoma = '95.102.218.189';
  const ipKarci = '81.92.253.99';

  // getIp().then((ip)=>{
  //   if(ip === ipKubo ||
  //     ip === ipKuboDoma ||
  //     ip === ipKarci ||
  //   ip === '62.197.241.122' ||
  //   ip.startsWith(ipTASR)){
  //     setShowElectionsBanner(true);
  //   }
  // }) 


  const ref = useWagonHeight("index");
  return (
    <div ref={ref}>     
    { showElectionsBanner &&
      <ElectionsBanner></ElectionsBanner>
    }
      {props.flash_news ? null : (        
        <HotTopics hotTopics={props.hot_topics} gaInfo={gaInfo} />
      )}      
      <section className="section">
        <div className="border-top container">
          <TopArticlesGrid
            aside={props.aside}
            articles={props.articles}
            top_article={props.top_article}
            right_now={props.right_now}
            broadcasts={props.broadcasts}
            gaInfo={gaInfo}
          />
          {/* <RightNow items={props.right_now} /> */}
          <TipsHorizontal
            items={props.tips} // noHeaderColumnLine={true}
            gaInfo={gaInfo}
          />
          {/* <BannerHorizontal {...props.banner_horizontal} /> */}          
          {(props.splits || []).map(asideMapping)}
        </div>
      </section>
    </div>
  );
};

export default WagonIndex;
